import React from "react";

import courseCard from "../../assets/images/courses_card.png";
import { ICompletedCourse } from "../../models/get-course.model.";

interface ModalProps {
    course: ICompletedCourse,
    onSelect: (politic: ICompletedCourse) => void;
}

export const CompletedCourseCard = ({ course, onSelect } : ModalProps) => {
    return (
        <div key={course.id}  className="completed-course-card">
            <div className="completed-course-card-body" onClick={() => onSelect(course)}>
                <div className="image-section-course">
                    <img src={courseCard} alt="certificate" />
                </div>
                <label>{course.name}</label>
            </div>
        </div>
    )
}